export const generateDateTimeFilename = (extension: string = 'xlsx', prefix?: string, postfix?: string) => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');

  let filename = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;

  if (prefix !== undefined) {
    filename = prefix + filename;
  }

  if (postfix !== undefined) {
    filename = filename + postfix;
  }

  return `${filename}.${extension}`;
}